import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { cn } from '../../../lib/utils';

const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English', shortLabel: 'EN' },
  { value: 'id', label: 'Indonesia', shortLabel: 'ID' },
  { value: 'th', label: 'Thai', shortLabel: 'TH' },
  { value: 'vi', label: 'Vietnamese', shortLabel: 'VI' },
  { value: 'zh', label: 'Chinese (Traditional)', shortLabel: 'ZH' },
] as const;

const SHORT_LABELS: Record<string, string> = Object.fromEntries(
  LANGUAGE_OPTIONS.map(({ value, shortLabel }) => [value, shortLabel])
);

export interface SwitchLanguageProps {
  /** Shows a narrower, short-code select (e.g. "EN" instead of "English")
   * for phone-sized viewports, where space is too limited for full
   * language names. */
  compact?: boolean;
}

export default function SwitchLanguage({ compact = false }: SwitchLanguageProps) {
  const { i18n } = useTranslation();

  const handleChange = (value: string) => {
    void i18n.changeLanguage(value);
  };

  const lang = i18n.resolvedLanguage ?? i18n.language;
  const current = LANGUAGE_OPTIONS.find((o) => o.value === lang)?.value ?? 'en';

  return (
    <div className="flex items-center gap-2 justify-end">
      <Select
        value={current}
        placeholder="Select Language"
        onChange={handleChange}
        className={cn('items-center', compact ? 'min-w-[52px] sm:min-w-[70px]' : 'min-w-[70px] sm:min-w-[90px]')}
        prefix={<FontAwesomeIcon icon={faGlobe} className="text-gray-600" />}
        suffixIcon={null}
        labelRender={compact ? ({ value }) => SHORT_LABELS[String(value)] ?? value : undefined}
        options={LANGUAGE_OPTIONS.map(({ value, label }) => ({
          value,
          label,
        }))}
      />
    </div>
  );
}
